module.exports = __webpack_public_path__ + "static/media/pose-hand.995286d3.jpg";